import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBuilding,
  cilCloud,
  cilCloudDownload,
  cilControl,
  cilEducation,
  cilEnvelopeClosed,
  cilFactory,
  cilHome,
  cilMonitor,
  cilSettings,
  cilStorage,
  cilSwapHorizontal,
  cilUser,
  cilUserFollow,
} from '@coreui/icons'

export const _nav = [
  {
    name: 'Home',
        to: '/',
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
    permissions: ['authenticated'],
  },
  {
    name: 'Email Inbox',
    to: '/emails',
    icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
    permission: 'agent-email-message-read',
  },
  {
    name: 'Agents',
    icon: <CIcon icon={cilControl} customClassName="nav-icon" />,
    permissions: [
      'agent-read',
    ],
    children: [
      {
        name: 'Email',
        to: '/agents/emails',
        icon: <CIcon icon={cilControl} customClassName="nav-icon" />,
        permission: 'agent-email-read',
      },
    ],
  },
  {
    name: 'Connectors',
    icon: <CIcon icon={cilSwapHorizontal} customClassName="nav-icon" />,
    permissions: ['connector-read'],
    children: [
      {
        name: 'Email Office365',
        to: '/connectors/email-office365',
        icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
        permission: 'connector-email-office365-read',
      },
      {
        name: 'AI',
        to: '/connectors/ai',
        icon: <CIcon icon={cilEducation} customClassName="nav-icon" />,
        permission: 'connector-ai-read',
      },
      {
        name: 'ERP',
        to: '/connectors/erp',
        icon: <CIcon icon={cilFactory} customClassName="nav-icon" />,
        permission: 'connector-erp-read',
      },
    ],
  },
  {
    name: 'Administration',
    icon: <CIcon icon={cilMonitor} customClassName="nav-icon" />,
    permissions: ['user-read', 'role-read'],
    children: [
      {
        name: 'Users',
        to: '/users',
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
        permission: 'user-read',
      },
      {
        name: 'Roles',
        to: '/roles',
        icon: <CIcon icon={cilUserFollow} customClassName="nav-icon" />,
        permission: 'role-read',
      },
    ],
  },
  {
    name: 'System',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
    permissions: ['logs-read'],
    children: [
      {
        name: 'Logs',
        to: '/logs',
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
        permission: 'logs-read',
      },
    ],
  },
]
